import globals from "./globals";
import $ from "cash-dom";
import Masonry from "masonry-layout";

const layout = (function () {
    /**
     * Initialize Contact Sheet instances
     */
    $(document).ready(function () {
        if ($(".layout-image-gallery").length) {
            if (globals.debug) console.log("layout-image-gallery initialized");
            $(window).on("load", function () {
                $(".layout-image-gallery").each(function () {
                    var container = $(this).find(".image-gallery")[0];

                    new Masonry(container, {
                        itemSelector: ".image-gallery-image",
                        transitionDuration: 0,
                    });
                });
            });
        }
    });
})();

export default layout;
